import { FC } from 'react'

export const Facebook: FC<{ isShare?: boolean }> = ({ isShare }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={isShare ? 'url(#golden-texture)' : 'currentColor'}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5251 1.48064C19.3781 0.741251 24.4919 3.94383 26.9859 8.51854C29.7938 13.6683 28.881 19.7694 25.344 23.8785C23.2073 26.3605 19.6168 28.4028 16.359 28.5556C11.8875 28.766 9.26622 27.8666 6.05037 25.3155C3.82257 23.5485 1.86674 20.3747 1.33727 16.378C0.58503 10.6964 4.00485 5.46297 8.31 3.10355C10.1299 2.10617 11.2249 1.77178 13.5251 1.48064ZM12.7714 0.180583C11.6329 0.438577 10.8749 0.529379 9.81304 0.928621C7.86299 1.65936 5.46883 3.08337 4.15385 4.59675C3.83849 4.95995 3.55061 5.2093 3.22801 5.64169C0.852656 8.8241 -0.3871 11.9575 0.107645 17.0612C0.881588 25.0417 9.29515 31.1543 16.9463 29.8153C20.7669 29.1465 24.34 27.4919 26.5895 24.4666C29.0936 21.0968 30.4809 17.5123 29.8473 12.8713C29.0604 7.10174 24.706 2.28921 19.5488 0.723955C17.7868 0.18923 14.7373 -0.264781 12.7699 0.180583H12.7714Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3949 13.0372C11.6416 13.5863 11.3363 11.9807 11.3363 15.0521C11.3363 16.3133 12.8842 15.3188 13.3414 15.8679C13.6943 16.5914 13.3312 20.6069 13.4846 21.8436C14.3048 22.0136 14.5348 21.9344 15.4332 21.93C16.3952 21.9243 16.0914 21.2252 16.0914 19.1166C16.0914 18.5487 16.0943 17.9794 16.0914 17.4115C16.0914 17.1608 16.0726 16.8538 16.0784 16.6131C16.0798 16.5439 16.0914 16.3003 16.1059 16.2412C16.278 15.473 16.8972 15.7973 18.1586 15.6676L18.4986 13.6699C18.5044 12.7057 17.2096 13.2764 16.1145 13.0617C16.0422 11.7472 15.8816 10.6633 17.0577 10.5149C18.4016 10.3434 18.7864 11.3148 18.5608 8.30681C12.8061 7.44923 13.771 10.499 13.3949 13.0357V13.0372Z"
      />
    </g>
  </svg>
)
